
export const APP_VERSION = '2.3.5'; // add  webhooks
export const BUILD_DATE = '29-10-2026';
